import {ResponseBase} from './ResponseBase';
import {IRequestBase, RawResponseType} from "./Types";

/**
 * @class RequestBase<TResponse> - abstract class for other request classes.
 */
export abstract class RequestBase<TResponse extends ResponseBase> implements IRequestBase {
    /**
     * @method createResponse - responsible for creating correct implementation of response class.
     * @param responseJson - created response class will be populated with this response json data.
     */
    abstract createResponse(responseJson: RawResponseType): TResponse;
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/RequestBase.ts
 **/